import { alpha, Box, InputBase, styled, Switch, Typography } from "@mui/material";


export const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15,
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(9px)',
      },
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(12px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: theme.palette.mode === 'dark' ? '#177ddc' : '#1890ff',
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(['width'], {
        duration: 200,
      }),
    },
    '& .MuiSwitch-track': {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
      boxSizing: 'border-box',
    },
  }));

  export const Container = styled(Box)`
    width: 100%;
    // height: 75vh;
    padding: 2rem 0;
    margin: auto;
    display: flex;
    flex-wrap: wrap;
    // justify-content: center;
  `;

  export const ContainerForm = styled(Box)`
    width: 40%;
    text-align: center;
    border-right: 1px solid black;
  `;

  export const ContainerFormRight = styled(Box)`
    width: 60%;
    margin-left: auto;
    text-align: center;
    border-right: 1px solid black;
  `;
  
  export const Title2 = styled(Typography)`
    text-align: center;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    margin: 1rem auto;
  `;
  
  export const Title = styled(Typography)`
    text-align: center;
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
    margin: 2rem auto;
  `;

  export const DashMain = styled(Box)`
    width: 100%;
    padding: 1rem;
    margin-top: 4rem;
    display: grid;
    grid-template-columns: 24.25% 24.25% 24.25% 24.25%;
    gap: 1rem;
  `;

  export const DashBox = styled(Box)`
    padding: 1rem;
    box-shadow: 0px 0px 10px 5px #e3e3e3;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    border-radius: 10px;
    transition: all 0.5s ease;

    &:hover {
      // width: 24%;
      background: #1976d2;

      * {
        color: white;
      }
    }

    div:nth-of-type(1) {
      width: 70%;
    }

    div:nth-of-type(2) {
      width: 28%;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #1976d2;
    }

    svg {
      font-size: 4rem;
    }
    
    h2 {
      font-weight: bold;
      font-size: 1.5rem;
      font-family:'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
    }

    span {
      color: #1976d2;
      font-weight: bold;
      font-size: 1.5rem;
      margin-left: 1rem;
    }
  `;

  export const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));

  export const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('md')]: {
        width: '20ch',
      },
    },
  }));